import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchRemoteConfig as fetchRemoteConfigService,
  fetchRemoteConfigValue as fetchRemoteConfigValueService,
} from "../../services/remoteConfig";

const initialState = {
  loader: false,
  remoteConfig: null,
  remoteConfigLoading: false,
  remoteConfigError: null,
};

export const startLoader = createAsyncThunk(
  "app/startLoader",
  async () => {
    return { loader: true };
  }
);

export const stopLoader = createAsyncThunk(
  "app/stopLoader",
  async () => {
    return { loader: false };
  }
);

export const appConfig = createAsyncThunk(
  "app/appConfig",
  async ({ isMobileDevice }, { rejectWithValue }) => {
    try {
      return { isMobileDevice };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchRemoteConfig = createAsyncThunk(
  "app/fetchRemoteConfig",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchRemoteConfigService();
    } catch (error) {
      return rejectWithValue(error?.message || "Unable to fetch remote config");
    }
  }
);

export const fetchRemoteConfigValue = createAsyncThunk(
  "app/fetchRemoteConfigValue",
  async ({ key, type, fallback }, { rejectWithValue }) => {
    try {
      const value = await fetchRemoteConfigValueService(key, type, fallback);

      return { key, value };
    } catch (error) {
      return rejectWithValue(error?.message || "Unable to fetch remote config");
    }
  }
);

export const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(startLoader.fulfilled, (state, action) => {
        state.loader = action.payload.loader;
      })
      .addCase(stopLoader.fulfilled, (state, action) => {
        state.loader = action.payload.loader;
      })
      .addCase(appConfig.fulfilled, (state, action) => {
        state.isMobileDevice = action.payload.isMobileDevice;
      })
      .addCase(fetchRemoteConfig.pending, (state) => {
        state.remoteConfigLoading = true;
        state.remoteConfigError = null;
      })
      .addCase(fetchRemoteConfig.fulfilled, (state, action) => {
        state.remoteConfigLoading = false;
        state.remoteConfig = action.payload;
      })
      .addCase(fetchRemoteConfig.rejected, (state, action) => {
        state.remoteConfigLoading = false;
        state.remoteConfigError = action.payload || action.error?.message;
      })
      .addCase(fetchRemoteConfigValue.pending, (state) => {
        state.remoteConfigLoading = true;
        state.remoteConfigError = null;
      })
      .addCase(fetchRemoteConfigValue.fulfilled, (state, action) => {
        state.remoteConfigLoading = false;
        state.remoteConfig = {
          ...(state.remoteConfig || {}),
          [action.payload.key]: action.payload.value,
        };
      })
      .addCase(fetchRemoteConfigValue.rejected, (state, action) => {
        state.remoteConfigLoading = false;
        state.remoteConfigError = action.payload || action.error?.message;
      });
  },
});

export default appSlice.reducer;
